module.exports = __webpack_public_path__ + "170d4ef92ab89a6fcacb659fd475b944.svg";